import { renderCartBubble, renderCartDrawer, renderCartPage } from './utils.js';

class LineItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cacheDomElements();
    this.setupEventListeners();
  }

  cacheDomElements() {
    this.toggleButton = this.querySelector('[js-line-item="toggle"]');
    this.components = this.querySelector('[js-line-item="components"]');
    this.removeButton = this.querySelector('[js-line-item="remove"]');
  }

  setupEventListeners() {
    this.toggleButton?.addEventListener('click', this.handleToggleEvent.bind(this));
    this.removeButton?.addEventListener('click', this.handleRemoveEvent.bind(this));
  }

  disconnectedCallback() {
    this.toggleButton?.removeEventListener('click', this.handleToggleEvent.bind(this));
    this.removeButton?.removeEventListener('click', this.handleRemoveEvent.bind(this));
  }

  handleToggleEvent() {
    this.components.classList.toggle('is-hidden');
    this.toggleButton.classList.toggle('is-active');

    if (this.components.classList.contains('is-hidden')) {
      this.toggleButton.querySelector('span').textContent = this.toggleButton.getAttribute('data-show-text');
      this.style.setProperty('--line-item-components-height', '0px');
    }

    else {
      this.toggleButton.querySelector('span').textContent = this.toggleButton.getAttribute('data-hide-text');
      this.style.setProperty('--line-item-components-height', 'auto');

      const componentsHeight = this.components.scrollHeight - 20;
      this.style.setProperty('--line-item-components-height', `${componentsHeight}px`);
    }
  }

  async handleRemoveEvent() {
    try {
      const key = this.dataset.key;
      this.classList.add('is-loading');

      if (!key) {
        console.warn('Line item key not found');
        return;
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: 0,
          sections: 'cart-drawer,cart-bubble,cart'
        }),
      }).then(res => res.json())

      renderCartBubble(response.sections['cart-bubble']);
      renderCartDrawer(response.sections['cart-drawer']);
      renderCartPage(response.sections['cart']);

      this.clearEditModeFromURL(key);
    } catch (error) {
      console.error(error);
    } finally {
      this.classList.remove('is-loading');
    }
  }

  clearEditModeFromURL(removedKey) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlKey = urlParams.get('key');

    if (urlKey === removedKey) {
      urlParams.delete('key');

      const newUrl = urlParams.toString()

        ? `${window.location.pathname}?${urlParams.toString()}`
        : window.location.pathname;

      window.history.replaceState({}, '', newUrl);
    }
  }
}

customElements.define('line-item', LineItem);
